import { trees } from "@/api/base/tree/manager";
import { upSort } from "@components/_util/util";

const user = {
  state: {
    resource: []
  },

  mutations: {
    SET_RESOURCE: (state, resource) => {
      state.resource = resource;
    }
  },

  actions: {
    resource({ commit }) {
      return new Promise((resolve, reject) => {
        trees()
          .then(res => {
            commit("SET_RESOURCE", upSort(res.result));
            resolve(upSort(res.result));
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default user;
